class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(searchTerm, this.getSearchSection());
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm, this.getSearchSection());
    }
  }

  onFocusOut() {
    setTimeout(() => {
      let header_search = this.closest('.header-new-search');
      if (!this.contains(document.activeElement) && !header_search) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchSection() {
    if (
      this.closest('.mobile_header_search') ||
      this.closest('.header__search') ||
      this.querySelector('.predictive-search--header')
    ) {
      return 'header-predictive-search';
    }
    return 'predictive-search';
  }

  getSearchResults(searchTerm, section) {
    const queryKey = `${section}:${searchTerm.replace(" ", "-").toLowerCase()}`;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
    let limit = 4;
    let resourceType = 'product';
    let limitScope = '';
    if (section == 'header-predictive-search') {
      limit = 10;
      resourceType = 'product,article';
      limitScope = `&${encodeURIComponent('resources[limit_scope]')}=each`;
    }
   fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${resourceType}&${encodeURIComponent('resources[limit]')}=${limit}${limitScope}&section_id=${section}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector(`#shopify-section-${section}`).innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
    
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
        if (window.innerWidth > 990) {
          let desktopSearch = document.querySelector('.inline_header_search.header-inline-pred');
          let headerDiv = document.querySelector('#shopify-section-header');
      
          if (desktopSearch && headerDiv) {
            let headerHeight = headerDiv.offsetHeight;
            const parentTop = headerDiv.getBoundingClientRect().top;
            const targetTop = desktopSearch.getBoundingClientRect().top;
            const relativeTop = targetTop - parentTop;
            let heightPred = headerHeight - relativeTop;
      
            let predictiveSearch = document.querySelector('.predictive-search--header');
            if (predictiveSearch) {
              predictiveSearch.style.top = heightPred + 'px';
            }
          }
        }
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
                  function initializeColorSwatchSliders() {
    document.querySelectorAll(".predictive-search__results-list-header .new-product-swatch").forEach(sliderElement => {
      new Swiper(sliderElement, {
        slidesPerView: 4.5,
        slidesPerGroup: 1,
        spaceBetween: 5,
        autoHeight: true,
        observer: true,
        observeParents: true,
        parallax: true,
        keyboard: {
    enabled: true,
    onlyInViewport: true, 
  },
  mousewheel: {
    enabled: true,
    forceToAxis: true,  
    sensitivity: 1,    
  }
      });
    });
  }

  initializeColorSwatchSliders();
    if(this.classList.contains('search-modal__form')){
    document.querySelector('body').classList.add('overflow-hidden')
    document.querySelector('#mega-menu-overlay').style.display = 'block';
    }
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
    document.querySelector('body').classList.remove('overflow-hidden')
    document.querySelector('#mega-menu-overlay').style.display = 'none';
  }
}

customElements.define('predictive-search', PredictiveSearch);
